// API layer for campaign endpoints
import axiosInstance from './axiosInstance';

export const getCampaigns = (companyId, params = {}) =>
	axiosInstance.get('/campaigns', { params: { companyId, ...params } });

export const getCampaign = (id, companyId) =>
	axiosInstance.get(`/campaigns/${id}`, { params: { companyId } });

export const createCampaign = (data, companyId) =>
	axiosInstance.post('/campaigns', data, { params: { companyId } });

export const updateCampaign = (id, data, companyId) =>
	axiosInstance.put(`/campaigns/${id}`, data, { params: { companyId } });

export const deleteCampaign = (id, companyId) =>
	axiosInstance.delete(`/campaigns/${id}`, { params: { companyId } });

export const cloneCampaign = (id, companyId) =>
	axiosInstance.post(`/campaigns/${id}/clone`, {}, { params: { companyId } });

export const sendCampaign = (id, companyId) =>
	axiosInstance.post(`/campaigns/${id}/send`, {}, { params: { companyId } });

export const sendTestEmail = (id, data, companyId) =>
	axiosInstance.post(`/campaigns/${id}/test`, data, { params: { companyId } });

export const getCampaignAnalytics = (id, companyId) =>
	axiosInstance.get(`/campaigns/${id}/analytics`, { params: { companyId } });

export const getCampaignMonthlyUsage = (companyId) =>
	axiosInstance.get('/campaigns/monthly-usage', { params: { companyId } });

// Additional APIs for lists and templates
export const getLists = (companyId) =>
	axiosInstance.post('/lists/all', { companyId });

export const getTemplates = (companyId) =>
	axiosInstance.get('/templates', { params: { companyId } });

export const getPurchasedTemplates = () =>
	axiosInstance.get('/templates/purchased');

export const getSystemAdminTemplates = () =>
	axiosInstance.get('/templates/system-admin-templates');

export const getSenders = (companyId) =>
	axiosInstance.get('/senders', { params: { companyId } });

export const getContacts = (listId, companyId, params = {}) => {
	const queryParams = { companyId, ...params };
	return axiosInstance.get(`/contacts/list/${listId}`, { params: queryParams });
};
